import { AiOutlineCloseCircle } from "react-icons/ai";
import { useAdmin } from "../../../context/admin";
import Modal from "../../common/Modal";
import styled from "styled-components";
import { format } from "date-fns";

export default function GroupDetails() {
    const { groupDetails, setGroupDetails } = useAdmin()
    return (
        <Modal>
            <TableWrapper>
                <Table>
                    <thead>
                        <tr>
                            <th>Passenger</th>
                            <th>Tour</th>
                            <th>Tour Date</th>
                            <th>Sale price</th>
                            <th>Tickets</th>
                        </tr>
                    </thead>
                    <tbody>
                        {groupDetails?.map((reservation, index) => (
                            <tr key={index}>
                                <td>{reservation.passenger.name}</td>
                                <td>{reservation.tour_id}</td>
                                <td>{format(new Date(reservation.reservation_date), 'dd/MM/yyyy')}</td>
                                <td>{reservation.price}</td>
                                <td>{reservation.tickets}</td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </TableWrapper>
            <div className="close" title="close"
            onClick={() => setGroupDetails(undefined)}
            >
                <AiOutlineCloseCircle/>
            </div>
        </Modal>
    );
}

const TableWrapper = styled.div`
width: 100%;
height: 100%;
overflow: hidden;
overflow-x: unset;
`

const Table = styled.table`
border-collapse: collapse;
position: relative;
table-layout: fixed;
height: 100%;
width: 100%;
min-width: 500px;
thead {
    width: 100%;
    background-color: #FFFFFF;
}
th {
    font-weight: 400;
    overflow: hidden;
    text-overflow: ellipsis;
    > button {
        width: 20px;
        height: 20px;
        color: #FFF;
        font-size: 18px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 auto;
        line-height: 40px;
        background-color: ${props => props.theme.white};
        border: 1px solid ${props => props.theme.black};
        border-radius: 5px;
        cursor: pointer;
        transition: transform .3s ease;
        &:active {
            transform: scale(0.8);
            }
    }
    >button.selected-all {
        background-color: ${props => props.theme.yellowDark};
    }
}
td {
    text-align: center;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    .flag {
        width: 30px;
    }
    button.select {
        width: 20px;
        height: 20px;
        color: #FFF;
        font-size: 18px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 auto;
        line-height: 40px;
        background-color: ${props => props.theme.white};
        border: 1px solid ${props => props.theme.black};
        border-radius: 5px;
        cursor: pointer;
        transition: transform .3s ease;
        &:active {
            transform: scale(0.8);
        }
    }
    button.selected {
        background-color: ${props => props.theme.yellowDark};
    }
    button.info {
        border: none;
        background-color: none;
        font-size: 16px;
        cursor: pointer;
    }
}
tr {
    height: 40px;
    width: 100%;
}
`